import { Injectable, type OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '@xilo-mono/common/config';
import { catchError, of, ReplaySubject, takeUntil } from 'rxjs';
import { EventLogCreateDTO } from '../constants/event.const';


@Injectable({ providedIn: 'root' })
export class EventService implements OnDestroy {
  eventsApiUrl = `${this.configService.eventsApiUrl}/`;
  private readonly destroyed$ = new ReplaySubject<boolean>(1);

  constructor(private http: HttpClient, private configService: ConfigService) {
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  logEvent(event: EventLogCreateDTO) {
    this.http.post(`${this.eventsApiUrl}event-logs`, event).pipe(
      takeUntil(this.destroyed$),
    ).subscribe({ error: (e: Error) => console.error(`Error logging event ${event.name}, companyId ${event.companyId} `, e) });
  }
}
